/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
class ScrollProgress extends HTMLElement {
  connectedCallback() {
    this.bar = document.createElement('div');
    this.bar.className = 'scroll-progress-bar';
    this.appendChild(this.bar);
    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, {
      passive: true
    });
    this.onScroll();
  }
  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
  }
  onScroll() {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const progress = scrollHeight > 0 ? scrollTop / scrollHeight * 100 : 0;
    this.bar.style.width = `${progress}%`;
  }
}
customElements.define('scroll-progress', ScrollProgress);
/******/ })()
;